import Metadata from "./Metadata.js";
import makeKey from "../cache/KeyGen.js";

const KeyGen = { makeKey };
const Cache = {
  Metadata,
  KeyGen
};
export default Cache;
